export enum App {
  LOGIN_REQUEST = '@app/LOGIN_REQUEST',
  LOGIN_SUCCESS = '@app/LOGIN_SUCCESS',
  LOGIN_SUCCESS_MFA_REQUIRED = '@app/LOGIN_SUCCESS_MFA_REQUIRED',
  LOGIN_FAIL = '@app/LOGIN_FAIL',

  LOGOUT_REQUEST = '@app/LOGOUT_REQUEST',
  LOGOUT_SUCCESS = '@app/LOGOUT_SUCCESS',
  LOGOUT_FAIL = '@app/LOGOUT_FAIL',

  FORGOT_PASSWORD_REQUEST = '@app/FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS = '@app/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAIL = '@app/FORGOT_PASSWORD_FAIL',

  FORGOT_PASSWORD_VERIFY_REQUEST = '@app/FORGOT_PASSWORD_VERIFY_REQUEST',
  FORGOT_PASSWORD_VERIFY_SUCCESS = '@app/FORGOT_PASSWORD_VERIFY_SUCCESS',
  FORGOT_PASSWORD_VERIFY_FAIL = '@app/FORGOT_PASSWORD_VERIFY_FAIL',

  RESET_PASSWORD_REQUEST = '@app/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS = '@app/RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAIL = '@app/RESET_PASSWORD_FAIL',

  MFA_VERIFY_REQUEST = '@app/MFA_VERIFY_REQUEST',
  MFA_VERIFY_SUCCESS = '@app/MFA_VERIFY_SUCCESS',
  MFA_VERIFY_FAIL = '@app/MFA_VERIFY_FAIL',

  MFA_RESEND_REQUEST = '@app/MFA_RESEND_REQUEST',
  MFA_RESEND_SUCCESS = '@app/MFA_RESEND_SUCCESS',
  MFA_RESEND_FAIL = '@app/MFA_RESEND_FAIL',

  GET_GOOGLE_USER_REQUEST = '@app/GET_GOOGLE_USER_REQUEST',
  GET_GOOGLE_USER_SUCCESS = '@app/GET_GOOGLE_USER_SUCCESS',
  GET_GOOGLE_USER_FAIL = '@app/GET_GOOGLE_USER_FAIL',

  GET_CARD_SESSION_REQUEST = '@app/GET_CARD_SESSION_REQUEST',
  GET_CARD_SESSION_SUCCESS = '@app/GET_CARD_SESSION_SUCCESS',
  GET_CARD_SESSION_FAIL = '@app/GET_CARD_SESSION_FAIL',
  DESTROY_CARD_SESSION = '@app/DESTROY_CARD_SESSION',

  SWITCH_PROFILE = '@app/SWITCH_PROFILE',
  SET_CURRENT_SITE = '@app/SET_CURRENT_SITE',
  SET_CURRENT_DATE_RANGE = '@app/SET_CURRENT_DATE_RANGE',

  SET_TIP_CALCULATOR_FORM_DIRTY = '@app/SET_TIP_CALCULATOR_FORM_DIRTY',
}
